import { useState, useCallback, useEffect } from 'react';
import { getSummaryHotEventStatsComments } from '@op/services';
import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import type { IDiscussionItem } from '../components/HotEventPanel/types';

/**
 * Hot Event Stats Comments Hook（Language/Channel 分布数据）
 * 使用 /summary/hot_event/stats_comments 接口
 */
export const useHotEventStatsComments = (
  item: IDiscussionItem | null,
  filterParams: Record<string, any> | undefined,
) => {
  const [statsData, setStatsData] = useState<any>(null);
  const { loading, wrapperCancelRequest } = useCancelRequestHook({
    clear: () => setStatsData(null),
  });

  // getSummaryHotEventStatsComments 不支持标准 config 模式，包装一层适配
  const wrappedService = useCallback(
    (config: any) => {
      return getSummaryHotEventStatsComments(config.data) as Promise<any>;
    },
    [],
  );

  const fetchStats = useCallback(
    (params: any) => {
      return wrapperCancelRequest(wrappedService, params).then(
        (data: any) => {
          setStatsData(data || null);
          return data;
        },
      );
    },
    [], // ⚠️ 依赖数组必须为空
  );

  // 自动请求
  useEffect(() => {
    if (!item?.cluster_id) {
      setStatsData(null);
      return;
    }

    if (!filterParams) {
      setStatsData(null);
      return;
    }
    const {channel_type, ...otherFilter} =  filterParams;
    fetchStats({
      ...otherFilter,
      cluster_id: item.cluster_id,
      start_time: item.start_time,
      end_time: item.end_time, 
    });
  }, [item?.cluster_id, item?.start_time, item?.end_time, filterParams, fetchStats]);

  return { statsData, loading };
};
